export default {
  path: 'match-games/:matchGameId',
  props: true,
  component: () =>
    import(
      /* webpackChunkName: "match-room-layout" */ '@/modules/match/MatchLayout.vue'
    ),
  children: [
    {
      path: '',
      name: 'Match',
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "match-room" */ '@/modules/match/views/Match'
        )
    },
    {
      path: 'ffa',
      name: 'FFAMatch',
      props: true,
      component: () =>
        import(
          /* webpackChunkName: "match-room" */ '@/modules/match/views/FFAMatch'
        )
    }
  ]
}
